/*
 * サブシステム名：XXXX
 * 機能名：運行実績一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import complements from '@/rahmen/complement'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'PrmUnkoJissekiList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdDateRangeBox,
    DdRadioButton,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      unkoStartYmdString: '',
      unkoEndYmdString: '',
      unkoJissekiNo: '',
      hacchusakiId: '',
      sharyoId: '',
      jomuinId: '',
      jissekiKakuninZumiFlgKbn: '9',
      jissekiShimeFlgKbn: '9'
    },
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstSharyoHeaders: header.mstSharyoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.unkoYmdDisp = elem.unkoYmd ? filter.dateFormatter(elem.unkoYmd) : ''
        elem.jissekiShukkoYmdDisp = elem.jissekiShukkoYmd ? filter.dateFormatter(elem.jissekiShukkoYmd) : ''
        elem.jissekiShukkoHmsDisp = elem.jissekiShukkoHms ? complements.parseTime(elem.jissekiShukkoHms, false).substr(0, 5) : ''
        elem.jissekiKikoYmdDisp = elem.jissekiKikoYmd ? filter.dateFormatter(elem.jissekiKikoYmd) : ''
        elem.jissekiKikoHmsDisp = elem.jissekiKikoHms ? complements.parseTime(elem.jissekiKikoHms, false).substr(0, 5) : ''
        elem.hatsuchiOdoMaterDisp = elem.hatsuchiOdoMater === 0 || elem.hatsuchiOdoMater ? filter.numericMinorDigitFormatter(elem.hatsuchiOdoMater, 1) : ''
        elem.chakuchiOdoMaterDisp = elem.chakuchiOdoMater === 0 || elem.chakuchiOdoMater ? filter.numericMinorDigitFormatter(elem.chakuchiOdoMater, 1) : ''
        elem.sokoKyoriDisp = elem.sokoKyori === 0 || elem.sokoKyori ? filter.numericMinorDigitFormatter(elem.sokoKyori, 1) : ''
        elem.jisshaKyoriDisp = elem.jisshaKyori === 0 || elem.jisshaKyori ? filter.numericMinorDigitFormatter(elem.jisshaKyori, 1) : ''
        elem.kushaKyoriDisp = elem.kushaKyori === 0 || elem.kushaKyori ? filter.numericMinorDigitFormatter(elem.kushaKyori, 1) : ''
        elem.untenJikanDisp = elem.untenJikan ? filter.numericFormatter(elem.untenJikan) : ''
        elem.sagyoJikanDisp = elem.sagyoJikan ? filter.numericFormatter(elem.sagyoJikan) : ''
        elem.taikiJikanDisp = elem.taikiJikan ? filter.numericFormatter(elem.taikiJikan) : ''
        elem.kyusokuJikanDisp = elem.kyusokuJikan ? filter.numericFormatter(elem.kyusokuJikan) : ''
        elem.sosekisairyoDisp = elem.sosekisairyo === 0 || elem.sosekisairyo ? filter.numericMinorDigitFormatter(elem.sosekisairyo, 4) : ''
        return elem
      })
    },
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.hacchusakiFlg === true
      })
    },
    filteredSharyoList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      })
    },
    filteredjomuinList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '03' &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'vwcmstsharyo', 'vwcmsteigyoshojininlist', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmUnkoJissekiList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '運行実績No', value: 'unkoJissekiNo' },
              { text: '配車先区分', value: 'haishaKbnNm' },
              { text: '所属営業所', value: 'shozokuEigyoshoNm' },
              { text: '車両', value: 'sharyoNm' },
              { text: '発注先', value: 'hacchusakiNm' },
              { text: '発注先車番', value: 'hacchusakiShaban' },
              { text: '発注先車種', value: 'hacchusakiShashuSbtNm' },
              { text: '発注先乗務員', value: 'hacchusakiJomuinNm' },
              { text: '発注先備考', value: 'hacchusakiBiko' },
              { text: '運行年月日', value: 'unkoYmdDisp', align: 'center' },
              { text: '実績確認済み', value: 'jissekiKakuninZumiFlgDisp' },
              { text: '実績締', value: 'jissekiShimeFlgDisp' },
              { text: '実績出庫年月日', value: 'jissekiShukkoYmdDisp', align: 'center' },
              { text: '実績出庫時刻', value: 'jissekiShukkoHmsDisp', align: 'center' },
              { text: '実績帰庫年月日', value: 'jissekiKikoYmdDisp', align: 'center' },
              { text: '実績帰庫時刻', value: 'jissekiKikoHmsDisp', align: 'center' },
              { text: '出庫場所', value: 'shukkoBasho' },
              { text: '帰庫場所', value: 'kikoBasho' },
              { text: '乗務員', value: 'jomuinNm' },
              { text: '同乗者', value: 'dojoshaNm' },
              { text: '稼働時間', value: 'kadouJikan', align: 'right' },
              { text: '発地オドメータ', value: 'hatsuchiOdoMaterDisp', align: 'right' },
              { text: '着地オドメータ', value: 'chakuchiOdoMaterDisp', align: 'right' },
              { text: '総走行距離', value: 'sokoKyoriDisp', align: 'right' },
              { text: '実車距離', value: 'jisshaKyoriDisp', align: 'right' },
              { text: '空車距離', value: 'kushaKyoriDisp', align: 'right' },
              { text: '運転時間', value: 'untenJikanDisp', align: 'right' },
              { text: '作業時間', value: 'sagyoJikanDisp', align: 'right' },
              { text: '待機時間', value: 'taikiJikanDisp', align: 'right' },
              { text: '休息時間', value: 'kyusokuJikanDisp', align: 'right' },
              { text: 'デジタコ取込', value: 'digitakoTorikomiFlgDisp' },
              { text: 'デジタコ運行ID', value: 'digitakoUnkoId' },
              { text: '総積載量', value: 'sosekisairyoDisp', align: 'right' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              unkoStartYmdString: '',
              unkoEndYmdString: '',
              unkoJissekiNo: '',
              hacchusakiId: '',
              sharyoId: '',
              jomuinId: '',
              jissekiKakuninZumiFlgKbn: '9',
              jissekiShimeFlgKbn: '9'
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmUnkoJissekiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('PrmUnkoJissekiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmUnkoJissekiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmUnkoJissekiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmUnkoJissekiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      // 選択状態初期化
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2prmd0500/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },

    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              unkoStartYmdString: '',
              unkoEndYmdString: '',
              unkoJissekiNo: '',
              hacchusakiId: '',
              sharyoId: '',
              jomuinId: '',
              jissekiKakuninZumiFlgKbn: '9',
              jissekiShimeFlgKbn: '9'
            }
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      if (this.conditions.unkoStartYmdString && this.conditions.unkoEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.unkoStartYmdString, this.conditions.unkoEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.unkoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.unkoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    }
  }
}
